export enum InstagramStatus {
  EXIST = 'EXIST',
  EMPTY = 'EMPTY',
  INCORRECT = 'INCORRECT'
}
